var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ops.length)?_c('pre',{staticClass:"kb-line-diff"},_vm._l((_vm.ops),function(op,idx){return _c('span',{key:idx,staticClass:"kb-line-diff__line",class:("kb-line-diff__line--" + (op.op))},[_c('span',{staticClass:"kb-line-diff__sigil"},[_vm._v(_vm._s(_vm.sigil(op.op)))]),_vm._v(_vm._s(op.text)),_c('br')])}),0):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76ed345d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/knowledge-base/kb-line-diff.vue
// module id = 882
// module chunks = 1